import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FieldArray, reduxForm, formValueSelector } from 'redux-form';
import submit from './submit';
import validate from './validate';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';

// Style
import cx from 'classnames';
import { Button } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import BlockUploader from './BlockUploader';
import Uploader from './Uploader';

// Translation
import messages from '../../../locale/jsonMessages';
import { FormattedMessage, injectIntl } from 'react-intl';
import FieldArrayComponent from '../../CommonFields/FieldArrayComponent';
import { formatLocaleData } from '../../../helpers/formatLocale';

import cs from '../../../components/commonStyle.css';
import s from './StaticBlockForm.css';

class StaticBlockForm extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    title: PropTypes.string.isRequired,
  };


  render() {

    const {
      error,
      handleSubmit,
      submitting,
      title,
      selectedCarTripTitle1Language,
      selectedCarTripDetails2Language,
      selectedCarTripDetails3Language
    } = this.props;
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <h1 className='siteAdminHeading'><FormattedMessage  {...messages.staticInfoBlock} /></h1>
        <form onSubmit={handleSubmit(submit)}>
          {error && <strong>{formatMessage(error)}</strong>}
          <div className="oneColumnGrid">
            <FieldArray
              name="carTripTitle1"
              component={FieldArrayComponent}
              activesFields={['language', 'title']}
              selectedLanguage={selectedCarTripTitle1Language}
              filedName="carTripTitle1"
              label={formatMessage(messages.titleAdminLabel)}
              placeholder={formatMessage(messages.titleAdminLabel)}
              isDouble
            />
            <div className='twoColumnGrid'>
              <div>
                <h3 className='siteAdminSubHeading'><FormattedMessage  {...messages.footerImageBlock} /> #1</h3>
                <div className={s.staticBlockFormCard}>
                  <div className="oneColumnGrid">
                    <div className='siteAdminDropZoneWrapper'>
                      <label className={cx('commonLabelText', cs.spaceBottom3)} ><FormattedMessage  {...messages.imageLabel} /></label>
                      <BlockUploader />
                    </div>
                    <FieldArray
                      name="carTripDetails2"
                      component={FieldArrayComponent}
                      activesFields={['language', 'title', 'content']}
                      selectedLanguage={selectedCarTripDetails2Language}
                      filedName="carTripDetails2"
                      label={formatMessage(messages.titleAdminLabel)}
                      placeholder={formatMessage(messages.titleAdminLabel)}
                    />
                  </div>
                </div>
              </div>
              <div>
                <h3 className='siteAdminSubHeading'><FormattedMessage  {...messages.footerImageBlock} /> #2</h3>
                <div className={s.staticBlockFormCard}>
                  <div className="oneColumnGrid">
                    <div className='siteAdminDropZoneWrapper'>
                      <label className={cx('commonLabelText', cs.spaceBottom3)} ><FormattedMessage  {...messages.imageLabel} /></label>
                      <Uploader />
                    </div>
                    <FieldArray
                      name="carTripDetails3"
                      component={FieldArrayComponent}
                      activesFields={['language', 'title', 'content']}
                      selectedLanguage={selectedCarTripDetails3Language}
                      filedName="carTripDetails3"
                      label={formatMessage(messages.titleAdminLabel)}
                      placeholder={formatMessage(messages.titleAdminLabel)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={cx(cs.spaceTop4, 'singleBtnFlexEnd')}>
            <Button className={cx(cs.btnPrimary)} type="submit" disabled={submitting}>
              <FormattedMessage  {...messages.save} />
            </Button>
          </div>
        </form>
      </div>
    );
  }

}

StaticBlockForm = reduxForm({
  form: 'StaticBlockForm', // a unique name for this form
  validate
})(StaticBlockForm);

const selector = formValueSelector('StaticBlockForm');

const mapState = (state) => ({
  selectedCarTripTitle1Language: selector(state, 'carTripTitle1'),
  selectedCarTripDetails2Language: selector(state, 'carTripDetails2'),
  selectedCarTripDetails3Language: selector(state, 'carTripDetails3'),
  activeLanguageCodes: state.runtime.isActiveLanguages.map(item => formatLocaleData(item))
});

export default compose(
  injectIntl,
  withStyles(cs, s),
  connect(mapState)
)(StaticBlockForm);